import React, {Component } from 'react';

// Styles
import '../App.css';


class Slider extends Component {
    state = {
    }
    componentDidMount() {
     
    }

    componentWillUnmount() {
        
    }

  render() {
    return (
      <div>
        <div className={"slider"}>
            {this.props.children}
        </div>
      </div>
    );
  }
}

export default Slider;



// WEBPACK FOOTER //
// ./src/components/Slider.js